import { AuctionACommandRepository, ConcatenatedBatches } from '@/Domain/AuctionA'
import { ProcedureId } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
export class InMemoryAuctionACommandRepository implements AuctionACommandRepository {
  async sendAuctionAData (
    // eslint-disable-next-line
    procedureId: ProcedureId,
    // eslint-disable-next-line
    accountId: AccountId,
    // eslint-disable-next-line
    concatenatedBatches: ConcatenatedBatches,
    // eslint-disable-next-line
    data: string
  ): Promise<boolean> {
    await wait(500)
    return true
  }
}
